import React from "react"

import {Typography} from "antd";
import Support from "../theme/components/Support";
import {applyLang} from "../../../i18n";
import {t} from "@lingui/core/macro"

const {Text }=Typography


export default class PreviewCaisse extends React.Component{

  state={
    returnUrl:""
  }

  componentDidMount() {
    this.setState({returnUrl:window.location.href})
  }

  isFloat(n){
    return Number(n) === n && n % 1 !== 0;
  }

  getCaisse()
  {
    const {org,}=this.props.context

    return org.caisses.filter((c)=>c.withObjectif && c.total<c.objectif && !c.paused && !c.hidden ).slice(0,3).map(i=>applyLang(i,this.props.context.lang))
  }


  render()
  {
    const context=this.props.context
    const {org,config,T}=this.props.context

    var caissesPreview=this.getCaisse()
    //caissesPreview=caissesPreview.slice(0,3)

    var mainLabel=config["don.main.label"] || t`Don Spontané`

    return <Support mainLabel={mainLabel} caisses={caissesPreview} context={context}/>
  }
}
